import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'font-awesome/css/font-awesome.css'

import App from './App.vue'
import SignIn from './components/SignIn.vue'
import HomeScreen from './components/HomeScreen.vue'
import UserStore from './vuex/user.store'

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.config.productionTip = false

const router = new VueRouter({
	mode : 'history',
	routes : [
		{ path : '/', redirect : '/home' },
		{ path : '/login', component : SignIn, beforeEnter : (to, from, next) => {
			if(UserStore.state.userId)
				next('/home');

			next();
		} },
		{ path : '/home', component : HomeScreen, beforeEnter : (to, from, next) => {
			if(!UserStore.state.userId)
				next('/login');

			next();
		} }
	]
})

new Vue({
	render: h => h(App),
	store : new Vuex.Store(UserStore),
	router
}).$mount("#app")
